<template>
    <div style="height: 100%; overflow: auto">
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <!-- <span class="sa-flexbox-body-title">Scheda ospite</span> -->
                <b-button v-show="jsonData.statoAttuale !== 'CONSOLIDATO' && jsonData.statoAttuale !== 'ANNULLATO'" size="sm" variant="outline-danger outline-primary-noborder sa-margin-right float-sm-right" @click="onClickCambiaStato('ANNULLATO')" class="mb-2"> Annulla </b-button>
                <b-button v-show="jsonData.statoAttuale !== 'CONSOLIDATO' && jsonData.statoAttuale !== 'ANNULLATO'" size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickCambiaStato('CONSOLIDATO')" class="mb-2"> Consolida </b-button>
                <b-button v-show="jsonData.statoAttuale === 'CONSOLIDATO'" size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickScaricaFatture('ASL')" class="mb-2"> Scarica Fatture A.S.L.</b-button>
                <b-button v-show="jsonData.statoAttuale === 'CONSOLIDATO'" size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickScaricaFatture('COMUNE')" class="mb-2"> Scarica Fatture Comune</b-button>
                <b-button v-show="jsonData.statoAttuale === 'CONSOLIDATO'" size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickScaricaFatture('OSPITI')" class="mb-2"> Scarica Fatture Ospiti</b-button>
            </b-col>
        </b-row>
        <b-card class="sa-card" header="Dettagli Flusso" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Tipo Flusso:</label>
                    <span class="sa-data"> {{ jsonData.codiceFlusso }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Mese Anno Riferimento:</label>
                    <span class="sa-data"> {{ formatDateTimeCustom(jsonData.meseAnnoRiferimento, "MMMM yyyy") }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Presidio:</label>
                    <span class="sa-data"> {{ jsonData.presidio }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Regime:</label>
                    <span class="sa-data"> {{ jsonData.descrizioneRegime }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Totale:</label>
                    <span class="sa-data"> {{ formatFloat(jsonData.totale, 2) }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Quota A.S.L.:</label>
                    <span class="sa-data"> {{ formatFloat(jsonData.quotaAsl, 2) }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Quota Comune:</label>
                    <span class="sa-data"> {{ formatFloat(jsonData.quotaComune, 2) }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Quota Utente:</label>
                    <span class="sa-data"> {{ formatFloat(jsonData.quotaUtente, 2) }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Numero Impegnative:</label>
                    <span class="sa-data"> {{ jsonData.numeroImpegnative }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Stato Attuale:</label>
                    <span class="sa-data"> {{ jsonData.statoAttuale }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Stato Attuale Data Ora:</label>
                    <span class="sa-data"> {{ formatDateTime(jsonData.statoAttualeDataOra) }}</span>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="Elenco Flussi" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData.listaFile" :fields="fields" :current-page="1" :per-page="1000" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                <template #cell(index)="row">
                    {{ row.index + 1 }}
                </template>
                <template #cell(actions)="{ item }">
                    <b-container class="bv-example-row">
                        <b-button v-show="jsonData.statoAttuale !== 'ANNULLATO'" size="sm" v-b-tooltip.hover :title="'Scarica ' + item.tipoFile" variant="btn btn-outline-info no-text" @click="onClickDownload(item)">
                            <b-icon icon="download"></b-icon>
                        </b-button>
                        <b-button size="sm" v-b-tooltip.hover :title="'Visualizza Dettaglio ' + item.tipoFile" variant="outline-secondary" @click="onClickView(item)">
                            <i class="bi bi-eye"></i>
                        </b-button>
                    </b-container>
                </template>
            </b-table>
        </b-card>
        <flussi-dettagli-modal-view-component ref="cmpFlussiDettaglioModalView"></flussi-dettagli-modal-view-component>
    </div>
</template>
<script>
import axios from "axios";
import "vue2-datepicker/index.css";
import UtilityMixin from "../../utility/UtilityMixin";
import FlussiDettagliModalViewComponent from "./FlussiDettagliModalViewComponent.vue";

export default {
    mixins: [UtilityMixin],
    components: { FlussiDettagliModalViewComponent },
    data() {
        return {
            pathResource: "/flussitestata",
            pathResourceDettaglio: "/flussifiles",
            pathResourceCambiaStato: "/flussitestatastatistorico",
            jsonData: {},
            statoFlusso: {},
            listKey: 0,
            fields: [
                {
                    label: "*",
                    key: "index",
                },
                {
                    label: "Tipo",
                    key: "tipoFile",
                },
                {
                    label: "Numero Righe",
                    key: "numeroRighe",
                },
                {
                    label: "",
                    class: "sa-table-column-action-double",
                    key: "actions",
                },
            ],
        };
    },
    mounted() {
        // let me = this;
        // me.id = this.$route.params.id;
        // console.log(me.id);
        // me.loadDataAccettazione();
    },
    // watch: {
    //     jsonData: {
    //         handler(jsonData) {
    //             this.$emit("update", jsonData);
    //         },
    //         deep: true,
    //     },
    // },
    methods: {
        setId(id) {
            let me = this;
            me.id = id;
            me.loadData();
        },
        onClickCambiaStato(stato) {
            console.log(stato);
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceCambiaStato;
            me.statoFlusso = { idFileTestata: me.id, stato: stato };
            UtilityMixin.methods.restCallPost(link, me.statoFlusso, me.saveSuccess, me.saveErrors);
        },
        saveSuccess() {
            let me = this;
            me.showmolalloading = false;
            me.loadData();
        },
        saveErrors(error) {
            let me = this;
            me.showmolalloading = false;
            this.$bvModal
                .msgBoxOk(error.response.data.messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                })
                .then((value) => {
                    console.log(value);
                })
                .catch((err) => {
                    console.log(err);
                });
            this.showModalLoading = false;
        },
        onClickScaricaFatture(categoria) {
            console.log(categoria);
        },
        onClickDownload(item) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceDettaglio + "/download/" + item.id;
            axios({
                url: link, //your url
                method: "GET",
                responseType: "blob", // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                let nomeFile = item.tipoFile + "_" + me.formatDateTimeCustom(me.jsonData.meseAnnoRiferimento, "MMMM yyyy");
                link.setAttribute("download", nomeFile + ".txt"); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        onClickView(item) {
            let me = this;
            me.$refs.cmpFlussiDettaglioModalView.init(item.id);
        },
        loadData() {
            let me = this;
            let path = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
            UtilityMixin.methods.restCallGet(path, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
        },
        loadDataError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>
